import React from 'react'
import SprintGame from '../components/sprint/SprintGame'

function SprintGamePage() {
  return (
    <div className="sprintSection">
      <SprintGame />
    </div>
  )
}

export default SprintGamePage
